export default __webpack_public_path__ + "static/media/field-img.fa0bf217.png";